import { InputNumber } from 'antd';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

const formatter = (value) => `${value}%`;
const parser = (value) => value.replace('%', '');

const DynamicFieldInputNumberPercent = ({ value, onChange, ...props }) => {
  return (
    <InputNumber
      value={value}
      onChange={onChange}
      min={0}
      max={100}
      formatter={formatter}
      parser={parser}
      {...props}
    />
  );
};

DynamicFieldInputNumberPercent.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
};

export default memo(DynamicFieldInputNumberPercent);
